import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './tab-selector-2.css'

const TabSelector2 = (props) => {
  const [tabSelector, setTabSelector] = useState(1)
  const [tabSelector1, setTabSelector1] = useState(1)
  return (
    <div
      id={props.tabSelector2Id}
      className={`tab-selector-2-container ${props.rootClassName} `}
    >
      <div className="tab-selector-2-thq-product-elm">
        <div className="tab-selector-2-thq-frame133-elm">
          <div className="tab-selector-2-thq-frame362-elm">
            <span className="tab-selector-2-thq-text-elm10 HeadingH1SB">
              Products
            </span>
            {tabSelector1 === 1 && (
              <div className="tab-selector-2-thq-frame348-elm1">
                <div className="tab-selector-2-thq-for-telecomunication-button-elm1">
                  <span className="tab-selector-2-thq-text-elm11">
                    For Telecomunication
                  </span>
                </div>
                <div
                  onClick={() => {
                    setTabSelector(2)
                    setTabSelector1(2)
                  }}
                  className="tab-selector-2-thq-for-banking-button-elm1"
                >
                  <span className="tab-selector-2-thq-text-elm12 BodyB1R">
                    For Banking &amp; Retail
                  </span>
                </div>
                <div
                  onClick={() => {
                    setTabSelector1(3)
                    setTabSelector(3)
                  }}
                  className="tab-selector-2-thq-for-goverment-elm1"
                >
                  <span className="tab-selector-2-thq-text-elm13 BodyB1R">
                    For Government
                  </span>
                </div>
              </div>
            )}
            {tabSelector1 === 2 && (
              <div className="tab-selector-2-thq-frame348-elm2">
                <div
                  onClick={() => {
                    setTabSelector(1)
                    setTabSelector1(1)
                  }}
                  className="tab-selector-2-thq-for-telecomunication-button-elm2"
                >
                  <span className="tab-selector-2-thq-text-elm14 BodyB1R">
                    For Telecomunication
                  </span>
                </div>
                <div className="tab-selector-2-thq-for-banking-button-elm2">
                  <span className="tab-selector-2-thq-text-elm15">
                    For Banking &amp; Retail
                  </span>
                </div>
                <div
                  onClick={() => {
                    setTabSelector(3)
                    setTabSelector1(3)
                  }}
                  className="tab-selector-2-thq-for-goverment-elm2"
                >
                  <span className="tab-selector-2-thq-text-elm16 BodyB1R">
                    For Government
                  </span>
                </div>
              </div>
            )}
            {tabSelector1 === 3 && (
              <div className="tab-selector-2-thq-frame348-elm3">
                <div
                  onClick={() => {
                    setTabSelector(1)
                    setTabSelector1(1)
                  }}
                  className="tab-selector-2-thq-for-telecomunication-button-elm3"
                >
                  <span className="tab-selector-2-thq-text-elm17 BodyB1R">
                    For Telecomunication
                  </span>
                </div>
                <div
                  onClick={() => {
                    setTabSelector1(2)
                    setTabSelector(2)
                  }}
                  className="tab-selector-2-thq-for-banking-button-elm3"
                >
                  <span className="tab-selector-2-thq-text-elm18 BodyB1R">
                    For Banking &amp; Retail
                  </span>
                </div>
                <div className="tab-selector-2-thq-for-goverment-elm3">
                  <span className="tab-selector-2-thq-text-elm19">
                    For Government
                  </span>
                </div>
              </div>
            )}
          </div>
          {tabSelector === 1 && (
            <div className="tab-selector-2-thq-frame373-elm1">
              <img
                loading="lazy"
                decoding="async"
                alt="imageI133"
                src="/external/imagei133-28f9-1500w.png"
                className="tab-selector-2-thq-image-elm1"
              />
              <div className="tab-selector-2-thq-frame374-elm1">
                <div className="tab-selector-2-thq-frame375-elm1">
                  <span className="tab-selector-2-thq-text-elm20 HeadingH2SB">
                    SIMbolic
                  </span>
                  <span className="tab-selector-2-thq-text-elm21 HeadingH3M">
                    “A Symbol of your Confidence in Daily Conversations”
                  </span>
                  <span className="tab-selector-2-thq-text-elm22 BodyB2R">
                    Cipta SIMbolic is an end-to-end system designed for the
                    dynamic mobile environment, covering everything from R&amp;D
                    to card personalization. This innovative approach enables us
                    to deliver cost-effective products and services with shorter
                    lead times, making SIMbolic a trusted symbol of confidence
                    in everyday communications.
                  </span>
                </div>
                <div className="tab-selector-2-thq-frame378-elm1">
                  <div className="tab-selector-2-thq-frame379-elm1">
                    <div className="tab-selector-2-thq-frame127-elm1">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="simcardI133"
                        src="/external/simcardi133-yo35.svg"
                        className="tab-selector-2-thq-simcard-elm"
                      />
                      <span className="tab-selector-2-thq-text-elm23 HeadingH5SB">
                        SIM Card &amp; (U)SIM Card
                      </span>
                      <span className="tab-selector-2-thq-text-elm24 BodyB3R">
                        SIMbolic offers a comprehensive portfolio, featuring
                        native and Java™ card OS platforms that support a wide
                        range of value-added services (VAS) applications.
                      </span>
                    </div>
                    <div className="tab-selector-2-thq-frame376-elm1">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="lightbulbI133"
                        src="/external/lightbulbi133-5egf.svg"
                        className="tab-selector-2-thq-lightbulb-elm1"
                      />
                      <span className="tab-selector-2-thq-text-elm25 HeadingH5SB">
                        Solutions &amp; Applications
                      </span>
                      <span className="tab-selector-2-thq-text-elm26 BodyB3R">
                        SIMbolic offers a diverse range of over 50 value-added
                        service applications, supporting solutions like NFC,
                        M2M, and Dynamic SIM Tool Kit (DSTK).
                      </span>
                    </div>
                  </div>
                  <div className="tab-selector-2-thq-frame377-elm1">
                    <img
                      loading="lazy"
                      decoding="async"
                      alt="boxI133"
                      src="/external/boxi133-34vd.svg"
                      className="tab-selector-2-thq-box-elm1"
                    />
                    <span className="tab-selector-2-thq-text-elm27 HeadingH5SB">
                      Fulfillment &amp; Packaging
                    </span>
                    <span className="tab-selector-2-thq-text-elm28 BodyB3R">
                      SIMbolic provides end-to-end fulfillment and packaging
                      services, ensuring secure handling of personalized cards
                      while optimizing production flexibility and logistics
                      efficiency.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {tabSelector === 2 && (
            <div className="tab-selector-2-thq-frame373-elm2">
              <img
                loading="lazy"
                decoding="async"
                alt="image1310"
                src="/external/image1310-v009-1500w.png"
                className="tab-selector-2-thq-image-elm2"
              />
              <div className="tab-selector-2-thq-frame374-elm2">
                <div className="tab-selector-2-thq-frame375-elm2">
                  <span className="tab-selector-2-thq-text-elm29 HeadingH2SB">
                    Savient
                  </span>
                  <span className="tab-selector-2-thq-text-elm30 HeadingH3M">
                    “Assure Your Payment in a Convenient Way”
                  </span>
                  <span className="tab-selector-2-thq-text-elm31 BodyB2R">
                    Savient offers a complete range of products, including
                    contact and dual interface options, NFC systems, and two
                    platforms with various memory sizes. We provide the latest
                    native and Java™ system specifications, along with
                    personalization and production services featuring diverse
                    software and hardware components.
                  </span>
                </div>
                <div className="tab-selector-2-thq-frame378-elm2">
                  <div className="tab-selector-2-thq-frame379-elm2">
                    <div className="tab-selector-2-thq-frame127-elm2">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="creditcard1311"
                        src="/external/creditcard1311-mqg.svg"
                        className="tab-selector-2-thq-creditcard-elm"
                      />
                      <span className="tab-selector-2-thq-text-elm32 HeadingH5SB">
                        Retail Payment Card
                      </span>
                      <span className="tab-selector-2-thq-text-elm33 BodyB3R">
                        Retail payment cards serve various sectors, including
                        grocery, hospitality, and healthcare, with additional
                        services for design, consulting, and personalization.
                      </span>
                    </div>
                    <div className="tab-selector-2-thq-frame376-elm2">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="lightbulb1311"
                        src="/external/lightbulb1311-effa.svg"
                        className="tab-selector-2-thq-lightbulb-elm2"
                      />
                      <span className="tab-selector-2-thq-text-elm34 HeadingH5SB">
                        Solutions &amp; Applications
                      </span>
                      <span className="tab-selector-2-thq-text-elm35 BodyB3R">
                        Savient offers tailored payment solutions with NFC TSM
                        integration and comprehensive support for electronic
                        payments.
                      </span>
                    </div>
                  </div>
                  <div className="tab-selector-2-thq-frame377-elm2">
                    <img
                      loading="lazy"
                      decoding="async"
                      alt="box1312"
                      src="/external/box1312-bu4g.svg"
                      className="tab-selector-2-thq-box-elm2"
                    />
                    <span className="tab-selector-2-thq-text-elm36 HeadingH5SB">
                      Banking Cards
                    </span>
                    <span className="tab-selector-2-thq-text-elm37 BodyB3R">
                      CIPTA specializes in banking cards, focusing on NSICCS
                      ATM/Debit migration. Partnering with Samsung, we develop
                      innovative applications and offer Mastercard-certified
                      ATM/Debit, credit, and prepaid cards using the latest EMV
                      and contactless technologies.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {tabSelector === 3 && (
            <div className="tab-selector-2-thq-frame373-elm3">
              <img
                loading="lazy"
                decoding="async"
                alt="image1313"
                src="/external/image1313-h3d-1500w.png"
                className="tab-selector-2-thq-image-elm3"
              />
              <div className="tab-selector-2-thq-frame374-elm3">
                <div className="tab-selector-2-thq-frame375-elm3">
                  <span className="tab-selector-2-thq-text-elm38 HeadingH2SB">
                    Secura
                  </span>
                  <span className="tab-selector-2-thq-text-elm39 HeadingH3M">
                    “The Utmost Solution for Your Security Document”
                  </span>
                  <span className="tab-selector-2-thq-text-elm40 BodyB2R">
                    Cipta addresses the government&apos;s demand for enhanced
                    security and functionality with our innovative smart card
                    solutions. Under the SecurA brand, we offer comprehensive
                    products designed for e-government, e-commerce, and border
                    control, providing a reliable solution for global identity
                    needs in the public sector.
                  </span>
                </div>
                <div className="tab-selector-2-thq-frame378-elm3">
                  <div className="tab-selector-2-thq-frame379-elm3">
                    <div className="tab-selector-2-thq-frame127-elm3">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="processor1314"
                        src="/external/processor1314-ggs.svg"
                        className="tab-selector-2-thq-processor-elm"
                      />
                      <span className="tab-selector-2-thq-text-elm41 HeadingH5SB">
                        Electronic ID
                      </span>
                      <span className="tab-selector-2-thq-text-elm42 BodyB3R">
                        E-ID projects are growing globally, driven by security
                        threats and rapid implementation in the smart card
                        identity sector.
                      </span>
                    </div>
                    <div className="tab-selector-2-thq-frame376-elm3">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="heartmedical1315"
                        src="/external/heartmedical1315-mkpc.svg"
                        className="tab-selector-2-thq-heartmedical-elm"
                      />
                      <span className="tab-selector-2-thq-text-elm43 HeadingH5SB">
                        Healthcare Cards
                      </span>
                      <span className="tab-selector-2-thq-text-elm44 BodyB3R">
                        Our healthcare cards offer a comprehensive solution from
                        enrollment to secure storage, with customized services
                        for each client.
                      </span>
                    </div>
                  </div>
                  <div className="tab-selector-2-thq-frame380-elm">
                    <div className="tab-selector-2-thq-frame127-elm4">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="usersquare1315"
                        src="/external/usersquare1315-qixh.svg"
                        className="tab-selector-2-thq-usersquare-elm"
                      />
                      <span className="tab-selector-2-thq-text-elm45 HeadingH5SB">
                        Driving License
                      </span>
                      <span className="tab-selector-2-thq-text-elm46 BodyB3R">
                        Serving as a personal identity document, a driving
                        license holds the same significance as a national ID,
                        necessitating high-level security.
                      </span>
                    </div>
                    <div className="tab-selector-2-thq-frame376-elm4">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="plane1315"
                        src="/external/plane1315-3jys.svg"
                        className="tab-selector-2-thq-plane-elm"
                      />
                      <span className="tab-selector-2-thq-text-elm47 HeadingH5SB">
                        Travel Document
                      </span>
                      <span className="tab-selector-2-thq-text-elm48 BodyB3R">
                        Our e-Passports feature advanced security layers to
                        safeguard personal information and enhance traveler
                        safety.
                      </span>
                    </div>
                  </div>
                  <div className="tab-selector-2-thq-frame381-elm">
                    <div className="tab-selector-2-thq-frame127-elm5">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="car1316"
                        src="/external/car1316-vlgj.svg"
                        className="tab-selector-2-thq-car-elm"
                      />
                      <span className="tab-selector-2-thq-text-elm49 HeadingH5SB">
                        Vehicle Registration Number (VRN)
                      </span>
                      <span className="tab-selector-2-thq-text-elm50 BodyB3R">
                        The government has implemented electronic vehicle
                        registration cards with enhanced security to combat car
                        theft.
                      </span>
                    </div>
                    <div className="tab-selector-2-thq-frame376-elm5">
                      <img
                        loading="lazy"
                        decoding="async"
                        alt="home1316"
                        src="/external/home1316-m3qm.svg"
                        className="tab-selector-2-thq-home-elm"
                      />
                      <span className="tab-selector-2-thq-text-elm51 HeadingH5SB">
                        Temporary Residence Permit (TRP)
                      </span>
                      <span className="tab-selector-2-thq-text-elm52 BodyB3R">
                        This card enhances security and simplifies verification
                        by integrating biometrics and meeting strict
                        anti-counterfeiting standards.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

TabSelector2.defaultProps = {
  rootClassName: '',
  tabSelector2Id: '',
}

TabSelector2.propTypes = {
  rootClassName: PropTypes.string,
  tabSelector2Id: PropTypes.string,
}

export default TabSelector2
